
$(function() {
	if (!!window.MSInputMethodContext && !!document.documentMode) {
		$('html').addClass('ie11');
	}

	checkCustomInputs();
    $('[data-background], img[data-src]').imageLoader();

    $('a.popup').click(function(e) {
        e.preventDefault();
        openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
    });

	$('body').tooltip({
		selector: '[data-toggle="tooltip-click"]',
		trigger: 'click',
		offset: "0,20",
        container: 'body',
	});

	$('#main').tooltip({
		selector: '[data-toggle="tooltip"]',
		offset: "0,20",
        container: 'body',
	});


	// flags bij messages uitklappen:
    // $('a.actions-selected').click(function() {
    //
    // 	$('.message-flags').fadeOut(200);
    //
    // 	var showContainer = $(this).data('container');
    //
    // 	console.log(showContainer);
    //
    //     if ($('.'+showContainer+'').is(':visible')) {
    //         $('.'+showContainer).hide();
    //     } else {
    //         $('.'+showContainer).show();
    //     }
    //
    //     return false;
    // });
    //
	// // fade out van flags bij messages
	// $('.message-flags').hover(
	// 	function(){},
	// 	function(){
	// 		$(this).fadeOut(200);
	// 	}
	// );


    $(document).on('click', 'a.confirm', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin    = $('.confirm-popin');
        var textYes   = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
        var textNo    = $(this).data('text-no')  || $popin.find('.no').data('text-no');
        var onConfirm = $(this).data('onconfirm') || '';

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('confirm'));
        $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
        $popin.find('.no').text(textNo);
        $popin.modal();

        if (onConfirm) {
            $popin.find('.yes').attr('onclick', onConfirm);
        }
    });

    $(document).on('click', 'a.show-alert', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $popin = $('.alert-popin');

        if ($popin.is(':visible')) {
            return;
        }

        $popin.find('.text').html($(this).data('alert'));
        $popin.modal();
    });

    $('input[type=number]').keyup(function() {
        var min   = parseInt($(this).attr('min'));
        var max   = parseInt($(this).attr('max'));
        var value = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }
    });


	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') == 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType == 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active');
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active');
   	}).on('click', function(e) {
        if ($(e.target).closest('.modal-content').length === 0) {
   		    $(this).modal('hide');
        }
	});

    $(window).resize(function() {
   		checkSidebarHeight();
   	}).resize();

    $('.dashboard-scores').on('click',function(){
    	var targetUrl = $(this).data('scores-url');
    	window.location.href = targetUrl;
	});


    // rating
    $(document).on('mouseenter', '.rating-wrapper .rating-star', function() {
        if ($(this).hasClass('disabled')) return;
        $(this).addClass('hover').prevAll().addClass('hover');
    });

    $(document).on('mouseleave', '.rating-wrapper .rating-star', function() {
        if ($(this).hasClass('disabled')) return;
        $(this).removeClass('hover').prevAll().removeClass('hover');
    });

    $(document).on('click init.rating', '.rating-wrapper .rating-star', function(e) {
        if (e.type !== 'init' && $(this).hasClass('disabled')) return;
        $(this).siblings().removeClass('active');
        $(this).addClass('active').prevAll().addClass('active');
        $(this).parent().find('input').val($(this).data('rating'));
    });

    $('.rating').each(function() {
        var $input   = $(this);
        var $wrapper = $('<div class="rating-wrapper form-control-static" />');
        var max      = $input.attr('max') || 5;
        var disabled = $input.prop('disabled');

        $wrapper.insertAfter($input);
        $input.appendTo($wrapper).addClass('hidden');

        for (var i = 1; i <= max; i++) {
            $wrapper.append('<span class="rating-star ' + (disabled ? 'disabled' : '') + '" data-rating="' + i + '" />');
        }

        $wrapper.find('[data-rating="' + $input.val() + '"]').trigger('init.rating');
    });

});

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};


$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
